,
<template>
  <div class="profile-dropdown">
    <div class="profile-header" @click="goTo('ViewProfile')">
      <img class="avatar" :src="profileImage" alt="User avatar" />
      <div class="profile-info">
        <h3>{{ username || "username" }}</h3>
        <p>{{ email || "email"}}</p>
      </div>
      <span class="status-dot"></span>
    </div>
    <!-- Plan card: usage + upgrade (free) or manage (paid), coloured per plan -->
    <PlanSummaryCard v-if="planInfo" :info="planInfo" class="menu-plan-card">
      <button v-if="planInfo.plan === 'free'" type="button" class="plan-card-btn" @click="goTo('upgrade-card')">
        Go Premium · $9.99/mo
      </button>
      <button v-else type="button" class="plan-card-btn" @click="goTo('manage-plan-card')">
        Manage plan
      </button>
    </PlanSummaryCard>
    <div class="menu">
      <div class="menu-item" @click="goTo('profile')">
        <i class="icon user-icon"></i>
        <span>My Profile</span>
      </div>
      <div class="menu-item" @click="goTo('pricing')">
        <svg class="menu-icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        <span>Pricing Plans</span>
      </div>
      <div class="menu-item" @click="goTo('analytics')">
        <svg class="menu-icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
        <span>Analytics</span>
      </div>
      <div class="menu-item" @click="goTo('favorites')">
        <i class="fa fa-star"></i>
        <span>Favorites</span>
      </div>
      <div class="menu-item" @click="goTo('myads')">
        <i class="icon post-icon"></i>
        <span>My Adds</span>
      </div>
      <div class="menu-item" @click="goTo('myListings')">
        <svg class="menu-icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11 L12 4 L21 11 L21 21 L3 21 Z"/><path d="M9 21 L9 14 L15 14 L15 21"/></svg>
        <span>My Listings</span>
      </div>
      <div class="menu-item" @click="goTo('myDeals')">
        <svg class="menu-icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
        <span>My Deals</span>
      </div>
      <div class="menu-item" @click="goTo('password')">
        <i class="icon lock-icon "></i>
        <span>Password</span>
      </div>

      <!-- Admin: opens the unified Admin Console (all sections live there now). -->
      <div v-if="userole" class="admin-section">
        <div class="menu-item" @click="goTo('AdminConsole')">
          <i class="fa-solid fa-user-shield"></i>
          <span>Admin</span>
        </div>
      </div>

    
      <div class="menu-item"  @click="logout()">
        <i class="icon logout-icon"></i>
        <span class="logout-text">Logout</span>
      </div>
      
    </div>
    <ContactUsModal 
  v-if="showContactModal"
  @close="showContactModal = false"
/>

  </div>
</template>

<script>
import userDetailsServices from "../../services/userDetailsService.js";
import defaultDP from "../icons/Avatar.svg";
import axiosInst from "../../utils/axiosinstance"; // Use authenticated axios instance
import { toast } from "vue-sonner";
import ContactUsModal from "../pages/Models/contactUs.vue";
import PlanSummaryCard from "./PlanSummaryCard.vue";
import { trackInteraction } from "../../utils/trackInteraction.js";
import { useSubscription, fetchSubscriptionStatus } from "@/composables/useSubscription";
import { trackUpgradeShown, trackUpgradeClick } from "@/utils/upgradeFunnel";
export default {
  data() {
    return {
     username: "Loading..",
    email: "loading@mail.com",
    profileImage:defaultDP ,
        showContactModal: false,
           userole: false,
           issuperAdmin: false,
           showAdminMenu: false,
    };
  },
 components: {ContactUsModal, PlanSummaryCard },
  created() {
    const userId = localStorage.getItem("userid");
    // Refresh the plan/usage each time the menu opens (post count changes).
    fetchSubscriptionStatus();

    // Fetch user details
    userDetailsServices
      .getUserInfo(userId)
      .then((response) => {
        this.username = response.data[0]?.userName || "unknown";
        this.email = response.data[0]?.email || "unknown";
      })
      .catch(() => {
        this.username = "unknown";
        this.email = "unknown";
      });

    userDetailsServices.getProfileImage(userId).then((imgUrl) => {
      this.profileImage = imgUrl || defaultDP;
    });
  },
    watch: {
    showPlanCard: {
      immediate: true,
      handler(visible) {
        if (visible) trackUpgradeShown("menu-card");
      },
    },
  },
    computed: {
    // Only once the status call has answered, so paid users never see a
    // flash of the Free card while the plan is still loading.
    planInfo() {
      return useSubscription().subscription.value || null;
    },
    // Free card = upgrade prompt (funnel-tracked)
    showPlanCard() {
      return this.planInfo?.plan === "free";
    },
    isProdEnv() {
      return import.meta.env.VITE_NODE_ENV === 'production';
    }
  },
async mounted(){
   try {
    const response = await axiosInst.post("/api/getoneusers", {
      userID: localStorage.getItem("userid")
    });
    
    if (response.data && response.data[0]) {
      const userRole = response.data[0].role;
      console.log("User role:", userRole); // Debug log
      // superAdmin has all adminOrg privileges (plus impersonation).
      this.userole = (userRole === "adminOrg" || userRole === "superAdmin");
      this.issuperAdmin = (userRole === "superAdmin");
      console.log("Admin access enabled:", this.userole); // Debug log
    }
  } catch (error) {
    console.error("Error fetching user role:", error);
    this.userole = false;
  }
},
  methods: {
    toggleAdminMenu() {
      console.log("toggleAdminMenu called, current state:", this.showAdminMenu);
      this.showAdminMenu = !this.showAdminMenu;
      console.log("toggleAdminMenu new state:", this.showAdminMenu);
    },
    goTo(page) {
      // Track every profile-dropdown item click (My Profile, Pricing Plans,
      // Analytics, Favorites, My Adds/Listings/Deals, Password, Admin, …).
      trackInteraction('navbar', 'profile-menu', { label: page, role: 'user' });
      switch (page) {
        case "ViewProfile":
          this.$router.push("/profile");
          break;
        case "profile":
          this.$router.push("/profile");
          break;
        case "favorites":
          this.$router.push("/favorites");
          break;
        case "myads":
          this.$router.push("/my-adds");
          break;
        case "myListings":
          this.$router.push("/my-listings");
          break;
        case "myDeals":
          this.$router.push("/my-deals");
          break;
        case "password":
          this.$router.push("/my-pass");
          break;
        case "pricing":
          this.$router.push({ path: "/pricing", query: { src: "menu-pricing" } });
          break;
        case "upgrade-card": // Free-plan card's "Go Premium" (tracked separately)
          trackUpgradeClick("menu-card");
          this.$router.push({ path: "/pricing", query: { src: "menu-card" } });
          break;
        case "manage-plan-card": // Paid-plan card's "Manage plan"
          this.$router.push({ path: "/pricing", query: { src: "menu-card" } });
          break;
        case "analytics":
          this.$router.push("/analytics");
          break;
        case "AdminConsole":
          this.$router.push("/admin-console");
          break;
        case "Admin":
          this.$router.push("/super");
          break;
        case "ServiceAudit":
          this.$router.push("/service-audit");
          break;
        case "AllServices":
          this.$router.push("/all-services");
          break;
        case "MetadataAdmin":
          this.$router.push("/admin/metadata");
          break;
        case "CrawlReport":
          this.$router.push("/crawl-report");
          break;
        case "CitywiseMetadataAdmin":
          this.$router.push("/admin/citywise-metadata");
          break;
        case "PlanUpgradeReport":
          this.$router.push("/admin/plan-upgrade-report");
          break;
        case "ExpiringSubscriptions":
          this.$router.push("/admin/expiring-subscriptions");
          break;
        case "SearchAnalytics":
          this.$router.push("/admin/search-analytics");
          break;
        case "UserFeedback":
          this.$router.push("/admin/feedback");
          break;
        case "DirectoryClaims":
          this.$router.push("/admin/directory-claims");
          break;
        case "BusinessListings":
          this.$router.push("/admin/business-listings");
          break;
        case "Impersonate":
          this.$router.push("/admin/impersonate");
          break;
        default:
          console.warn("Unknown page:", page);
      }
    },


logout() {
  // Track the logout BEFORE we clear localStorage. Capture the user id/name
  // explicitly (label + extra) so "which user logged out" is recorded even
  // though the auth token is wiped a moment later in this same function.
  // IP, city/state, page and time are added server-side.
  trackInteraction('navbar', 'logout', {
    role: 'user',
    label: this.username && this.username !== 'Loading..' ? this.username : (localStorage.getItem('userid') || ''),
    extra: { userId: localStorage.getItem('userid') || '', userName: this.username, email: this.email },
  });
  const userlogid = localStorage.getItem("userlogid");
  const logintime = localStorage.getItem("logintime");
  const userid = localStorage.getItem("userid");
  const time = new Date().toISOString();

  console.log("logout() called");
  console.log("userlogid:", userlogid);
  console.log("logintime:", logintime);
  console.log("userid:", userid);
  console.log("time:", time);

  const requests = [];
  if (userlogid && userid && logintime) {
    const userlogPayload = {
      userlogId: userlogid,
      userID: userid,
      loginTime: logintime,
      lastActiveTime: time,
      status: "inactive",
    };
    console.log("updateuserlog payload:", userlogPayload);
    requests.push(
      axiosInst.put("/api/updateuserlog", userlogPayload)
    );
  }
  if (userid) {
    const updateUserPayload = {
      userID: userid,
      status: "inactive",
    };
    console.log("updateoneuser payload:", updateUserPayload);
    requests.push(
      axiosInst.put("/api/updateoneuser", updateUserPayload)
    );
  }

  Promise.all(requests)
    .catch((err) => {console.log("logout error:", err); /* ignore errors, proceed with logout */})
    .finally(() => {
   
      
  localStorage.removeItem('auth-token');
  localStorage.removeItem('userid');
  localStorage.removeItem('username');
  localStorage.removeItem('email');
  localStorage.removeItem('redirectTo');
  // ...remove any other keys you use

  // Remove cookies by setting them to expired
  document.cookie = "jwt-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "auth-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  // Optionally clear all localStorage (if you want a full reset)
  localStorage.clear();

      toast.success("Logout successfully");
      if (window.location.pathname === "/") {
        window.location.reload();
      } else {
        window.location.href = "/";
      }
    });
}


  },
};
</script>

<style scoped>
.profile-dropdown {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  font-family: var(--font-primary, "Inter", sans-serif);
  width: 240px;
  box-sizing: border-box;
  /* Keep the dropdown within the viewport: it is anchored at top:50px
     (see .dropdown-position in Navigation.vue), so cap its height and
     scroll vertically when the menu (esp. the expanded Admin submenu)
     would otherwise overflow the screen and clip the bottom items. */
  max-height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: hidden;
}

.profile-header {
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 4px 12px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s;
}
.profile-header:hover {
  background: #f8faff;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.profile-info {
  margin-left: 10px;
  overflow: hidden;
  min-width: 0;
  flex: 1 1 auto;
}

.profile-info h3 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-info p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
  position: absolute;
  left: 28px;
  top: 28px;
  border: 1.5px solid #ffffff;
}

/* Menu items */
.menu {
  margin-top: 6px;
}

.menu-plan-card {
  margin: 10px 2px 4px;
}
.plan-card-btn {
  width: 100%;
  margin-top: 2px;
  border: none;
  border-radius: 8px;
  background: var(--plan-accent);
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  font-family: inherit;
  padding: 8px;
  cursor: pointer;
}
.plan-card-btn:hover {
  background: var(--plan-accent-hover);
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  gap: 9px;
  border-radius: 7px;
  transition: background 0.15s;
}

.menu-item span {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  min-width: 0;
}

.menu-item:hover {
  background: #f1f5f9;
}

.icon {
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

.user-icon {
  background-image: url("../icons/userdrop.svg");
}
.post-icon {
  background-image: url("../icons/mypost.svg");
}
.lock-icon {
  background-image: url("../icons/lock.svg");
}
.logout-icon {
  background-image: url("../icons/exit.svg");
}

.menu-icon-svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #6b7280;
  stroke: #6b7280;
}

.menu-item:hover .menu-icon-svg {
  color: #3467d5;
  stroke: #3467d5;
}

.logout-text {
  color: #ef4444 !important;
  font-weight: 600;
}

/* Admin submenu styles */
.admin-section {
  margin: 0;
}

.admin-toggle {
  display: flex;
  align-items: center;
}

.submenu {
  margin: 2px 0 2px 8px;
  background: #f8faff;
  border-radius: 7px;
  border-left: 2px solid #dbeafe;
  overflow: hidden;
}

.submenu-item {
  display: flex;
  align-items: center;
  padding: 7px 10px 7px 12px;
  cursor: pointer;
  gap: 8px;
  font-size: 12px;
  color: #374151;
  transition: background 0.15s;
  border-radius: 5px;
}

.submenu-item:hover {
  background: #eff6ff;
}

.submenu-item i {
  font-size: 12px;
  width: 14px;
  text-align: center;
  color: #6b7280;
}

/* Slide transition */
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from {
  max-height: 0;
  opacity: 0;
}

.slide-enter-to {
  max-height: 300px;
  opacity: 1;
}

.slide-leave-from {
  max-height: 300px;
  opacity: 1;
}

.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

@media (max-width: 768px) {
  .profile-dropdown {
    width: min(280px, calc(100vw - 24px));
    max-width: calc(100vw - 24px);
    max-height: min(calc(100dvh - 72px), 560px);
  }

  .profile-header {
    align-items: flex-start;
    padding-right: 8px;
  }

  .profile-info h3,
  .profile-info p {
    max-width: 100%;
  }

  .menu-item {
    padding: 10px;
  }
}
</style>
